module.exports = __webpack_public_path__ + "media/banner_bg.69ebb6b8.mp4";